// Generated by purs version 0.15.16
import * as API_Account from "../API.Account/index.js";
import * as API_Pagination from "../API.Pagination/index.js";
import * as API_SelStudent from "../API.SelStudent/index.js";
import * as Concur_Core_LiftWidget from "../Concur.Core.LiftWidget/index.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Concur_React_DOM from "../Concur.React.DOM/index.js";
import * as Concur_React_Props from "../Concur.React.Props/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as $$Error from "../Error/index.js";
import * as Form_StudentSelect from "../Form.StudentSelect/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_Luxon from "../Internal.Luxon/index.js";
import * as Internal_SelectionMap from "../Internal.SelectionMap/index.js";
import * as Internal_Util from "../Internal.Util/index.js";
import * as Steps_FormPicker from "../Steps.FormPicker/index.js";
import * as Steps_Step1_State from "../Steps.Step1.State/index.js";
import * as Steps_Step1_Update from "../Steps.Step1.Update/index.js";
import * as Translate from "../Translate/index.js";
import * as Widget_Pager from "../Widget.Pager/index.js";
import * as Widgets_BetterSelect from "../Widgets.BetterSelect/index.js";
import * as Widgets_Checkbox from "../Widgets.Checkbox/index.js";
import * as Widgets_Confirmation from "../Widgets.Confirmation/index.js";
import * as Widgets_Dropdown from "../Widgets.Dropdown/index.js";
import * as Widgets_Loading from "../Widgets.Loading/index.js";
import * as Widgets_Modal from "../Widgets.Modal/index.js";
import * as Widgets_Search from "../Widgets.Search/index.js";
import * as Widgets_Signature_Request from "../Widgets.Signature.Request/index.js";
import * as Widgets_UpdateForm from "../Widgets.UpdateForm/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Concur_Core_Types.functorWidget);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var multiAlternativeWidget = /* #__PURE__ */ Concur_Core_Types.multiAlternativeWidget(Data_Monoid.monoidArray);
var abbr = /* #__PURE__ */ Concur_React_DOM.abbr(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var text = /* #__PURE__ */ Concur_React_DOM.text(Concur_Core_LiftWidget.liftWidgetWidget);
var time = /* #__PURE__ */ Concur_React_DOM.time(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var div = /* #__PURE__ */ Concur_React_DOM.div(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var h3$prime = /* #__PURE__ */ Concur_React_DOM["h3$prime"](multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var span = /* #__PURE__ */ Concur_React_DOM.span(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var ordRNTY = /* #__PURE__ */ GraphQL_Type.ordRNTY(Data_Ord.ordString);
var selectionCheckbox$prime = /* #__PURE__ */ Internal_SelectionMap["selectionCheckbox$prime"](ordRNTY);
var length = /* #__PURE__ */ Data_Foldable.length(Data_List_Types.foldableList)(Data_Semiring.semiringInt);
var article = /* #__PURE__ */ Concur_React_DOM.article(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var label = /* #__PURE__ */ Concur_React_DOM.label(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var map3 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorFn);
var selectAllCheckbox = /* #__PURE__ */ Internal_SelectionMap.selectAllCheckbox(Data_Functor.functorArray)(Data_Foldable.foldableArray)(ordRNTY);
var fromFoldable = /* #__PURE__ */ Data_Set.fromFoldable(Data_Foldable.foldableArray)(ordRNTY);
var intersection = /* #__PURE__ */ Data_Set.intersection(ordRNTY);
var meter = /* #__PURE__ */ Concur_React_DOM.meter(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Concur_React_Props.functorProps);
var length1 = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var section = /* #__PURE__ */ Concur_React_DOM.section(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var ol = /* #__PURE__ */ Concur_React_DOM.ol(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var show1 = /* #__PURE__ */ Data_Show.show($$Error.showErrorWrapper);
var a = /* #__PURE__ */ Concur_React_DOM.a(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var button = /* #__PURE__ */ Concur_React_DOM.button(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var fromFoldable1 = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var sortWith = /* #__PURE__ */ Data_Array.sortWith(Data_Ord.ordString);
var fromFoldable2 = /* #__PURE__ */ Data_Map_Internal.fromFoldable(ordRNTY)(Data_Foldable.foldableArray);
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var isEmpty = /* #__PURE__ */ Internal_SelectionMap.isEmpty(ordRNTY);
var header = /* #__PURE__ */ Concur_React_DOM.header(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var h1 = /* #__PURE__ */ Concur_React_DOM.h1(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var notEq = /* #__PURE__ */ Data_Eq.notEq(API_Account.eqAccType);
var bind = /* #__PURE__ */ Control_Bind.bind(Concur_Core_Types.bindWidget);
var div$prime = /* #__PURE__ */ Concur_React_DOM["div$prime"](multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var pure = /* #__PURE__ */ Control_Applicative.pure(Concur_Core_Types.applicativeWidget);
var updateFormsSelectionModal = function (state) {
    return function (v) {
        if (v instanceof Steps_Step1_Update.UpdateSemester) {
            return map(map1(Steps_Step1_Update.UpdateSemesterSelected.create))(Widgets_UpdateForm.semesterUpdateModal(Steps_Step1_State.selectedForms(state)));
        };
        if (v instanceof Steps_Step1_Update.UpdateTeacher) {
            return map(map1(Steps_Step1_Update.UpdateTeacherSelected.create))(Widgets_UpdateForm.teacherUpdateModal(Steps_Step1_State.selectedForms(state)));
        };
        throw new Error("Failed pattern match at Steps.Step1.View (line 83, column 35 - line 87, column 79): " + [ v.constructor.name ]);
    };
};
var renderRecentForms = function (state) {
    var studentFormType = function (form) {
        return abbr([ Concur_React_Props.title(form.form_type.label), Concur_React_Props.className("form-abbr"), Concur_React_Props.style({
            backgroundColor: form.form_type.bgColor
        }) ])([ text(form.form_type.abbr) ]);
    };
    var studentFormTime = function (form) {
        var v = Internal_Luxon.fromISO(form.updated_at);
        if (v instanceof Data_Maybe.Nothing) {
            return time([ Concur_React_Props.className("time"), Concur_React_Props.dateTime(form.updated_at) ])([ text("Failed parsing datetime") ]);
        };
        if (v instanceof Data_Maybe.Just) {
            return time([ Concur_React_Props.className("time"), Concur_React_Props.dateTime(form.updated_at), Concur_React_Props.title(Internal_Luxon.toLocaleString(Internal_Luxon.dateTimeFull)(v.value0)) ])([ text(Internal_Luxon.toRelative(v.value0)) ]);
        };
        throw new Error("Failed pattern match at Steps.Step1.View (line 418, column 13 - line 432, column 64): " + [ v.constructor.name ]);
    };
    var studentFormInfo = function (form) {
        return div([ Concur_React_Props.className("info") ])([ div([ Concur_React_Props.className("recent-form-header") ])([ h3$prime(API_SelStudent.studentName_(state.formPicker.workQueueCache.account)(form.student)(function (name) {
            return [ text(name) ];
        })(function (v) {
            return [ text(v.legal), span([ Concur_React_Props.className("preferred-name-paren") ])([ text(" (" + (v.preferred + ")")) ]) ];
        })), Form_StudentSelect.renderTags(form.student) ]), text(form.subtitle + (" " + (function () {
            var $90 = Data_Maybe.isJust(form.legacy_url);
            if ($90) {
                return Translate.lookupTranslation("legacy-form-label");
            };
            return "";
        })())) ]);
    };
    var studentFormCheck = function (form) {
        var props = [ Concur_React_Props["_id"](GraphQL_Type.innerId(form.id) + "-checkbox") ];
        return map(function (v) {
            return {
                formPicker: state.formPicker,
                recentForms: state.recentForms,
                searchState: state.searchState,
                searchVersion: state.searchVersion,
                state: state.state,
                selection: v
            };
        })(selectionCheckbox$prime(form.id)(form)(props)(state.selection));
    };
    var selectAllCheck = (function () {
        var selCount = length(Internal_SelectionMap.listSelected(state.selection));
        var render = function (selected) {
            return article([ Concur_React_Props.className("student-form select-all") ])([ Widgets_Checkbox.checkbox([ Concur_React_Props["_id"]("select-all-checkbox") ])(selected), div([ Concur_React_Props.className("info") ])([ label([ Concur_React_Props.htmlFor("select-all-checkbox") ])([ text((function () {
                var $91 = selCount > 0;
                if ($91) {
                    return show(selCount) + Translate.lookupTranslation("selected-count");
                };
                return Translate.lookupTranslation("select-all");
            })()) ]) ]) ]);
        };
        var formTuples = map2(function (f) {
            return new Data_Tuple.Tuple(f.id, f);
        })(API_Pagination.pageItems(state.recentForms));
        return map(map3(Data_Either.Left.create)(function (v) {
            return {
                formPicker: state.formPicker,
                recentForms: state.recentForms,
                searchState: state.searchState,
                searchVersion: state.searchVersion,
                state: state.state,
                selection: v
            };
        }))(selectAllCheckbox(formTuples)(render)(state.selection));
    })();
    var renderFormIndicators = function (form) {
        var sigKeys = fromFoldable(map2(function (v) {
            return v.key;
        })(form.signatures));
        var fieldKeys = fromFoldable(map2(function (v) {
            return v.key;
        })(form.form_type.signatures));
        var signedCount = Data_Set.size(intersection(sigKeys)(fieldKeys));
        var fieldCount = Data_Set.size(fieldKeys);
        var sigCountStr = show(signedCount) + (" / " + show(fieldCount));
        var commentCount = Data_Array.length(form.comments);
        var attachCount = Data_Array.length(form.attachments);
        return div([ Concur_React_Props.className("recent-form-indicators") ])(Data_Array.catMaybes([ Internal_Util.justIf(Data_Maybe.isJust(form.locked_at))(div([ Concur_React_Props.className("recent-form--indicator recent-form-locked tooltip") ])([ div([ Concur_React_Props.className("image-replace") ])([  ]), div([ Concur_React_Props.className("tip-content") ])([ text(Translate.lookupTranslation("locked")) ]) ])), Internal_Util.justIf(commentCount > 0)(div([ Concur_React_Props.className("recent-form--indicator recent-form-comments tooltip") ])([ div([ Concur_React_Props.className("image-replace") ])([  ]), div([ Concur_React_Props.className("tip-content") ])([ text(show(commentCount) + (" " + Translate.lookupTranslation("comments"))) ]) ])), Internal_Util.justIf(attachCount > 0)(div([ Concur_React_Props.className("recent-form--indicator recent-form-attachments tooltip") ])([ div([ Concur_React_Props.className("image-replace") ])([  ]), div([ Concur_React_Props.className("tip-content") ])([ text(show(attachCount) + (" " + Translate.lookupTranslation("attachments"))) ]) ])), Internal_Util.justIf(fieldCount > 0)(div([ Concur_React_Props.className("recent-form--indicator recent-form-signatures tooltip") ])([ div([ Concur_React_Props.className("image-replace") ])([  ]), meter([ Concur_React_Props["_id"](GraphQL_Type.innerId(form.id) + "-signature-meter"), Concur_React_Props.key(GraphQL_Type.innerId(form.id) + "-signature-meter"), Concur_React_Props.min(show(0)), Concur_React_Props.max(show(fieldCount)), Concur_React_Props.value(show(signedCount)) ])([ text(sigCountStr) ]), div([ Concur_React_Props.className("tip-content") ])([ text(sigCountStr + (" " + Translate.lookupTranslation("signatures"))) ]) ])) ]));
    };
    var renderRecentForm = function (form) {
        return article([ Concur_React_Props.className("student-form"), Concur_React_Props.key("recent-form-" + GraphQL_Type.innerId(form.id)) ])([ label([ Concur_React_Props.htmlFor(GraphQL_Type.innerId(form.id) + "-checkbox") ])([ map(Data_Either.Left.create)(studentFormCheck(form)), studentFormType(form) ]), div([ voidRight(new Data_Either.Right(new Steps_Step1_Update.EditDocument(form)))(Concur_React_Props.onClick), Concur_React_Props.className("recent-form-info-wrapper") ])([ studentFormInfo(form), div([ Concur_React_Props.className("recent-form-extra") ])([ studentFormTime(form), map(Data_Either.Right.create)(renderFormIndicators(form)) ]) ]) ]);
    };
    var listRecentForms = (function () {
        if (length1(API_Pagination.pageItems(state.recentForms)) === 0) {
            return [ div([ Concur_React_Props.className("recent-forms-empty"), Concur_React_Props.dangerouslySetInnerHTML({
                "__html": Translate.lookupTranslation("recent-forms-empty")
            }) ])([  ]) ];
        };
        return append1([ selectAllCheck ])(map2(renderRecentForm)(API_Pagination.pageItems(state.recentForms)));
    })();
    return section([ Concur_React_Props.className("recent-forms"), Concur_React_Props.key("recent-forms-list") ])([ div([ Concur_React_Props.className("recent-form-group") ])([ div([ Concur_React_Props.className("dropdown") ])([  ]) ]), map(map3(Data_Either.Right.create)(Steps_Step1_Update.SearchChanged.create))(Widgets_Search.searchWidget(state.searchState)), (function () {
        if (state.state instanceof Steps_Step1_State.RFNormal) {
            return ol([ Concur_React_Props.className("recent-form-list") ])(listRecentForms);
        };
        if (state.state instanceof Steps_Step1_State.RFLoading) {
            return Widgets_Loading.loadingWidget;
        };
        if (state.state instanceof Steps_Step1_State.RFError) {
            return text("Error: " + show1(state.state.value0));
        };
        throw new Error("Failed pattern match at Steps.Step1.View (line 291, column 7 - line 294, column 54): " + [ state.state.constructor.name ]);
    })(), map(map3(Data_Either.Right.create)(Steps_Step1_Update.ChangePage.create))(Widget_Pager.pagerWidget(state.recentForms)) ]);
};
var renderMiscDropdown = function (state) {
    var nonUpdatableFormSelected = Data_Array.any(function ($121) {
        return !(function (v) {
            return v.can.update;
        })($121);
    })(Steps_Step1_State.selectedForms(state));
    var updateFormsItem = function (action) {
        return function (label1) {
            if (nonUpdatableFormSelected) {
                return a([ Concur_React_Props.className("dropdown-item disabled whitespace-nowrap"), Concur_React_Props.title(Translate.lookupTranslation("update-forms-disabled-reason-lock")) ])([ text(label1) ]);
            };
            return a([ voidRight(action)(Concur_React_Props.onClick), Concur_React_Props.className("dropdown-item whitespace-nowrap") ])([ text(label1) ]);
        };
    };
    var items = [ updateFormsItem(Steps_Step1_Update.UpdateSemester.value)(Translate.lookupTranslation("update-semester")), updateFormsItem(Steps_Step1_Update.UpdateTeacher.value)(Translate.lookupTranslation("update-teacher")) ];
    var busy = (function () {
        if (state.state instanceof Steps_Step1_State.RFLoading) {
            return true;
        };
        return false;
    })();
    var btn = button([ Concur_React_Props.className("btn vdots"), Concur_React_Props.disabled(busy), Concur_React_Props.onClick ])([ text("\u2807") ]);
    return map(map3(Data_Either.Right.create)(Steps_Step1_Update.UpdateForms.create))(Widgets_Dropdown.dropdownButton_(btn)(items));
};
var renderExportDropdown = function (state) {
    var combineExports = function (exps) {
        var id = (Data_Array_NonEmpty.head(exps)).label;
        return {
            id: id,
            label: id
        };
    };
    var busy = (function () {
        if (state.state instanceof Steps_Step1_State.RFLoading) {
            return true;
        };
        return false;
    })();
    var btn = button([ Concur_React_Props.className("export-forms-button btn"), Concur_React_Props.title(Translate.lookupTranslation("export-forms")), Concur_React_Props.disabled(busy), Concur_React_Props.onClick ])([ span([ Concur_React_Props.className("export-forms icon") ])([  ]) ]);
    var allExports = map2(function (v) {
        return v.exports;
    })(fromFoldable1(Internal_SelectionMap.listSelected(state.selection)));
    var groupedExports = Data_Array.groupBy(function (a1) {
        return function (b) {
            return a1.label === b.label;
        };
    })(sortWith(function (v) {
        return v.label;
    })(Data_Array.concat(allExports)));
    var exports = map2(combineExports)(groupedExports);
    var items = map2(function (exp) {
        return {
            label: exp.label,
            value: exp
        };
    })(exports);
    return map(map3(Data_Either.Right.create)(Steps_Step1_Update.ExportDocuments.create))(Widgets_Dropdown.dropdownButton(btn)(items));
};
var renderEmailDropdown = function (state) {
    var docRels = function (sigs) {
        return map2(function (s) {
            return new Data_Tuple.Tuple(s.relationship, s.relationship_label);
        })(Data_Array.filter(function (v) {
            return v.can.request;
        })(sigs));
    };
    var busy = (function () {
        if (state.state instanceof Steps_Step1_State.RFLoading) {
            return true;
        };
        return false;
    })();
    var btn = button([ Concur_React_Props.className("request-sigs-button btn"), Concur_React_Props.title(Translate.lookupTranslation("request-signatures")), Concur_React_Props.disabled(busy), Concur_React_Props.onClick ])([ span([ Concur_React_Props.className("request-sigs icon") ])([  ]) ]);
    var allRels = fromFoldable2(Data_Array.concatMap(function (doc) {
        return docRels(doc.form_type.signatures);
    })(fromFoldable1(Internal_SelectionMap.listSelected(state.selection))));
    var items = map2(function (v) {
        return {
            label: v.value1,
            value: v.value0
        };
    })(toUnfoldable(allRels));
    var $101 = Data_Array.length(items) > 0;
    if ($101) {
        return map(map3(Data_Either.Right.create)(Steps_Step1_Update.RequestSignatures.create))(Widgets_Dropdown.dropdownButton(btn)(items));
    };
    return Widgets_Dropdown.dropdownButton_(btn)([ div([ Concur_React_Props.className("dropdown-item whitespace-nowrap") ])([ text(Translate.lookupTranslation("request-signatures-no-sigs")) ]) ]);
};
var renderWidget = function (state) {
    var selected = fromFoldable1(Internal_SelectionMap.listSelected(state.selection));
    var formPickerEdit = (function () {
        if (state.formPicker.reorder) {
            return button([ voidRight(new Data_Either.Right(Steps_Step1_Update.SaveFormOrder.value))(Concur_React_Props.onClick), Concur_React_Props.className("form-picker-re-order-save button btn") ])([ text(Translate.lookupTranslation("save")) ]);
        };
        return button([ voidRight(new Data_Either.Right(Steps_Step1_Update.StartFormReorder.value))(Concur_React_Props.onClick), Concur_React_Props.className("form-picker-re-order button btn") ])([ span([ Concur_React_Props.className("re-order-icon") ])([  ]), text(Translate.lookupTranslation("re-order")) ]);
    })();
    var everyDocumentLocked = Data_Array.all(function ($122) {
        return Data_Maybe.isJust((function (v) {
            return v.locked_at;
        })($122));
    })(fromFoldable1(Internal_SelectionMap.listSelected(state.selection)));
    var toggleLocksClass = (function () {
        if (everyDocumentLocked) {
            return "unlock";
        };
        return "lock";
    })();
    var toggleLocksLabel = (function () {
        if (everyDocumentLocked) {
            return "Unlock";
        };
        return "Lock";
    })();
    var canToggleLocks = !Data_Array["null"](selected) && Data_Array.all(function (form) {
        return form.can.lock;
    })(selected);
    var busy = (function () {
        if (state.state instanceof Steps_Step1_State.RFLoading) {
            return true;
        };
        return false;
    })();
    var bulkActionsVisible = !isEmpty(state.selection);
    return div([ Concur_React_Props.className("step-container step-1") ])([ header([ Concur_React_Props.className("page-header") ])(Data_Array.catMaybes([ new Data_Maybe.Just(h1([ Concur_React_Props.className("page-heading") ])([ text(Translate.lookupTranslation("recent-forms")) ])), Internal_Util.justIf(bulkActionsVisible)(div([ Concur_React_Props.className("mm-land") ])(Data_Array.catMaybes([ new Data_Maybe.Just(button([ Concur_React_Props.className("edit-forms-button btn"), Concur_React_Props.title(Translate.lookupTranslation("edit-forms")), Concur_React_Props.disabled(busy), voidRight(new Data_Either.Right(Steps_Step1_Update.EditDocuments.value))(Concur_React_Props.onClick) ])([ span([ Concur_React_Props.className("edit-forms icon") ])([  ]) ])), Internal_Util.justIf(canToggleLocks)(button([ Concur_React_Props.className("toggle-lock-forms-button btn " + (toggleLocksClass + "-button")), Concur_React_Props.title(toggleLocksLabel), Concur_React_Props.disabled(busy), voidRight(new Data_Either.Right(Steps_Step1_Update.ToggleDocumentLocks.value))(Concur_React_Props.onClick) ])([ span([ Concur_React_Props.className("icon " + (toggleLocksClass + "-forms")) ])([  ]) ])), new Data_Maybe.Just(button([ Concur_React_Props.className("copy-forms-button btn"), Concur_React_Props.title(Translate.lookupTranslation("copy-forms")), Concur_React_Props.disabled(busy), voidRight(new Data_Either.Right(Steps_Step1_Update.CopyDocuments.value))(Concur_React_Props.onClick) ])([ span([ Concur_React_Props.className("copy-forms icon") ])([  ]) ])), Internal_Util.justIf(notEq(state.formPicker.workQueueCache.account.type)(API_Account.StudentAccount.value))(button([ Concur_React_Props.className("delete-forms-button btn"), Concur_React_Props.title(Translate.lookupTranslation("delete-forms")), Concur_React_Props.disabled(busy), voidRight(new Data_Either.Right(Steps_Step1_Update.DeleteDocuments.value))(Concur_React_Props.onClick) ])([ span([ Concur_React_Props.className("delete-forms icon") ])([  ]) ])), new Data_Maybe.Just(renderExportDropdown(state)), new Data_Maybe.Just(renderEmailDropdown(state)), new Data_Maybe.Just(renderMiscDropdown(state)) ]))), new Data_Maybe.Just(button([ Concur_React_Props.className("create-forms-button btn btn-primary"), voidRight(new Data_Either.Right(Steps_Step1_Update.CreateForms.value))(Concur_React_Props.onClick) ])([ text(Translate.lookupTranslation("create-forms")) ])) ])), div([ Concur_React_Props.className("form-picker-container") ])([ formPickerEdit, map(map3(Data_Either.Right.create)(Steps_Step1_Update.FormPickerChanged.create))(Steps_FormPicker.renderFormPicker(state.formPicker)) ]), div([ Concur_React_Props.className("step-1-right") ])([ renderRecentForms(state) ]) ]);
};
var copyStudentsModal = function (state) {
    return bind(Form_StudentSelect.selectStudentModal(div$prime([  ]))(Translate.lookupTranslation("copy-forms-select-students"))(new Data_Maybe.Just({
        "class": state["searchState"]["class"],
        keyword: state.searchState.keyword,
        semester: state.searchState.semester,
        teacher: Widgets_BetterSelect.setSelected(state.searchState.teacher)(Data_Maybe.Nothing.value)
    })))(function (result) {
        return pure((function () {
            if (result instanceof Widgets_Modal.ModalClosed) {
                return Data_Maybe.Nothing.value;
            };
            if (result instanceof Widgets_Modal.ModalReturned) {
                return new Data_Maybe.Just(result.value0.students);
            };
            throw new Error("Failed pattern match at Steps.Step1.View (line 78, column 10 - line 80, column 53): " + [ result.constructor.name ]);
        })());
    });
};
var step1MessageWidget = function (state) {
    var modalActionWhileLoading = function (action) {
        if (state.state instanceof Steps_Step1_State.RFLoading) {
            if (action instanceof Steps_Step1_Update.CopyDocuments) {
                return true;
            };
            if (action instanceof Steps_Step1_Update.DeleteDocuments) {
                return true;
            };
            if (action instanceof Steps_Step1_Update.RequestSignatures) {
                return true;
            };
            if (action instanceof Steps_Step1_Update.UpdateForms) {
                return true;
            };
            return false;
        };
        return false;
    };
    return bind(renderWidget(state))(function (res) {
        if (res instanceof Data_Either.Left) {
            return pure(new Steps_Step1_Update.StateChanged(res.value0));
        };
        if (res instanceof Data_Either.Right && modalActionWhileLoading(res.value0)) {
            return pure(new Steps_Step1_Update.ViewAction(res.value0));
        };
        if (res instanceof Data_Either.Right && res.value0 instanceof Steps_Step1_Update.CopyDocuments) {
            return map(Steps_Step1_Update.CopyStudentsSelected.create)(copyStudentsModal(state));
        };
        if (res instanceof Data_Either.Right && res.value0 instanceof Steps_Step1_Update.DeleteDocuments) {
            return map(Steps_Step1_Update.DeleteConfirmed.create)(Widgets_Confirmation.confirmModal(renderRecentForms(state))(Translate.lookupTranslation("confirm-delete-forms-title"))(Translate.lookupTranslation("confirm-delete-forms-primary-button"))(Translate.lookupTranslation("confirm-delete-forms")));
        };
        if (res instanceof Data_Either.Right && res.value0 instanceof Steps_Step1_Update.RequestSignatures) {
            return map(Steps_Step1_Update.SignatureRequestsSelected.create)(Widgets_Signature_Request.signatureRequestModal(state.formPicker.workQueueCache.account)(Steps_Step1_State.selectedForms(state))(res.value0.value0));
        };
        if (res instanceof Data_Either.Right && res.value0 instanceof Steps_Step1_Update.UpdateForms) {
            return map(Steps_Step1_Update.FormsUpdateSelected.create)(updateFormsSelectionModal(state)(res.value0.value0));
        };
        if (res instanceof Data_Either.Right) {
            return pure(new Steps_Step1_Update.ViewAction(res.value0));
        };
        throw new Error("Failed pattern match at Steps.Step1.View (line 44, column 5 - line 62, column 34): " + [ res.constructor.name ]);
    });
};
export {
    step1MessageWidget,
    copyStudentsModal,
    updateFormsSelectionModal,
    renderWidget,
    renderExportDropdown,
    renderMiscDropdown,
    renderEmailDropdown,
    renderRecentForms
};
//# sourceMappingURL=index.js.map
